<template>
  <div
    class="achievement-list"
    :style="{ marginTop: searchComp ? '15px' : '5px' }"
  >
    <div class="flex items-center achievement-top" v-if="searchComp">
      <div v-if="achievementData.length !== 0 && total !== 0">
        <div
          v-if="achievementData.length !== 0 && total !== 0 && !isDialogText"
          class="all-data-tips"
        >
          为您找到 <span>{{ total }}条</span> 结果
        </div>
        <div v-else class="all-data-tips">
          <div v-if="activeValue === '专利'">
            <p>
              <span>{{ total }}条</span> 合作专利
            </p>
            <p class="hint-text">
              <span>*</span>说明：展示与该机构合作过的全部专利
            </p>
            <!--            <p v-if="isDialogText === '专利合作'" class="hint-text"><span>*</span>说明：展示与该机构合作过的全部专利</p>-->
            <!--            <p v-else class="hint-text"><span>*</span>说明：展示与该机构和该篇专利学者合作过的全部专利</p>-->
          </div>
          <div v-else-if="activeValue === '论文'">
            <p>
              <span>{{ total }}条</span> 合作论文
            </p>
            <p class="hint-text">
              <span>*</span>说明：展示与该机构合作过的全部论文
            </p>
          </div>
          <div v-else>
            为您找到 <span>{{ total }}条</span> 结果
          </div>
        </div>
      </div>
      <!--      <div class="flex items-center patent-layout" v-if="(activeValue === '专利'||activeValue === '论文') && searchComp">-->
      <div
        class="flex items-center patent-layout justify-end"
        v-if="activeValue === '论文' && searchComp"
      >
        <div class="flex patent-sort-view">
          <span>排序：</span>
          <p
            class="pointer"
            @click="clickSortBy(item.name)"
            :class="[sortValue == item.name ? 'p-select-color' : '']"
            v-for="(item, index) in sortData"
            :key="index"
          >
            <span v-if="index == 1 || index == 2" class="sort-line">|</span>
            {{ item.name }}
          </p>
        </div>
      </div>
    </div>
    <div
      v-else
      class="achievement-view"
      :style="{ padding: searchComp ? '' : '0' }"
    >
      <!--   论文   -->
      <div v-if="activeValue === '论文'">
        <div
          class="achievement-item paper-item"
          v-for="paper in achievementData"
          :key="paper.id"
        >
          <h3 class="title">
            <span @click="toDetail(paper.id, '/paperDetail')">{{
              paper.title
            }}</span>
          </h3>
          <ul class="info">
            <li class="inventor ellipsis">
              <span style="min-width: 39px">作者：</span>
              <p
                style="cursor: pointer"
                v-for="author in paper.authors.length < 10
                  ? paper.authors
                  : paper.authors.slice(0, 10)"
                :key="author.scholarId"
                @click="goPersonalDetails(author.scholarId || author.id)"
              >
                <el-avatar
                  :size="22"
                  style="min-width: 22px"
                  :src="author.avatarUrl"
                ></el-avatar>
                <span
                  class="overflow overflow-one"
                  style="max-width: 93px"
                  :title="author.scholarName"
                  >{{ author.scholarName || author.name }}</span
                >
              </p>
            </li>
            <li>
              <span style="min-width: 52px">出版物：</span>
              <p style="max-width: 150px" :title="paper.venue" class="ellipsis">
                {{ paper.venue || '-' }}
              </p>
            </li>
          </ul>
          <ul class="info">
            <li>
              <span>卷号：</span>
              <p>{{ paper.volume || '-' }}</p>
            </li>
            <li>
              <span>引用次数：</span>
              <p>{{ paper.citationNum || 0 }}</p>
            </li>
            <li>
              <span>发表时间：</span>
              <p>{{ paper.date ? formatToDate(paper.date) : '-' }}</p>
            </li>
          </ul>
        </div>
      </div>

      <!--   专利   -->
      <div v-else-if="activeValue === '专利'">
        <div
          class="achievement-item"
          v-for="patent in achievementData"
          :key="patent.id"
        >
          <h3 class="title">
            <span @click="toDetail(patent.id, '/patentDetail')">{{
              patent.title
            }}</span>
          </h3>
          <ul class="info">
            <li class="inventor ellipsis">
              <span>发明人：</span>
              <p v-if="!patent.authors || patent.authors.length === 0">-</p>
              <p
                v-else
                v-for="(author, index) in patent.authors.length>3?patent.authors.slice(0,3):patent.authors"
                :key="author.scholarId"
                style="cursor: pointer"
                @click="goPersonalDetails(author.scholarId)"
              >
                <el-avatar
                  :size="22"
                  style="min-width: 22px"
                  :src="author.avatarUrl"
                  v-if="index < 6"
                ></el-avatar>
                <span v-if="index < 6">{{ author.scholarName || '-' }}</span>
              </p>
            </li>
            <li>
              <span>申请人：</span>
              <p>{{ patent.applicantName || '-' }}</p>
            </li>
            <li>
              <span>申请时间：</span>
              <p>
                {{
                  patent.applicationDate
                    ? formatToDate(patent.applicationDate)
                    : '-'
                }}
              </p>
            </li>
          </ul>
          <ul class="info">
            <li>
              <span>专利类型：</span>
              <p>{{ patent.patentType || '-' }}</p>
            </li>
            <li>
              <span>公开日期：</span>
              <p>
                {{
                  patent.publicationDate
                    ? formatToDate(patent.publicationDate)
                    : '-'
                }}
              </p>
            </li>
            <!--            <li><span>公开(公告)号：</span><p>{{ patent.authorizationNum || '-' }}</p></li>-->
            <li>
              <span>公开(公告)号：</span>
              <p>{{ patent.publicationNum || '-' }}</p>
            </li>
            <li style='margin-top: 6px'>
              <span>申请号：</span>
              <p>{{ patent.applicationNum || '-' }}</p>
            </li>
          </ul>
        </div>
      </div>

      <!--   项目   -->
      <div v-else-if="activeValue === '项目'">
        <div
          class="achievement-item project-item"
          v-for="project in achievementData"
          :key="project.id"
        >
          <h3 class="title">
            <span @click="toDetail(project.id, '/projectDetail')">{{
              project.title || '-'
            }}</span>
          </h3>
          <ul class="info" style="">
            <li class="inventor ellipsis" v-if="project.leader">
              <span>负责人：</span>
              <p
                v-if="project.leader"
                style="cursor: pointer"
                @click="goPersonalDetails(project.leader.id)"
              >
                <el-avatar
                  :size="22"
                  :src="project.leader && project.leader.avatar"
                ></el-avatar>
                <span>{{ project.leader && project.leader.scholarName }}</span>
              </p>
              <p v-else>-</p>
            </li>
            <li v-if="project.startYear">
              <span>批准年份：</span>
              <p>
                {{ project.startYear || '' }}
              </p>
            </li>
            <li v-if="project.typeFirst">
              <span>项目类别：</span>
              <p>
                {{ project.typeFirst || '-' }}
              </p>
            </li>
            <li v-if="project.projectSource">
              <span>项目来源：</span>
              <p>{{ project.projectSource || '-' }}</p>
            </li>
          </ul>
        </div>
      </div>

      <!--   奖项   -->
      <div v-else-if="activeValue === '奖项'">
        <div
          class="achievement-item project-item"
          v-for="(award, index) in achievementData"
          :key="index"
        >
          <h3 class="title">
            <span>{{ award.awardName }}</span>
          </h3>
          <ul class="info">
            <li class="inventor ellipsis">
              <span>获奖人：</span>
              <p
                class="pointer"
                style="cursor: pointer"
                v-for="peo in award.authors.length < 10
                  ? award.authors
                  : award.authors.slice(0, 10)"
                :key="peo.scholarId"
                @click="goPersonalDetails(peo.scholarId)"
              >
                <el-avatar :size="22" :src="peo.avatarUrl"></el-avatar>
                <span>{{ peo.scholarName }}</span>
              </p>
            </li>
            <li v-if="award.awardProject">
              <span>获得奖项：</span>
              <p>{{ award.awardProject || '-' }}</p>
            </li>
            <li>
              <span>获奖时间：</span>
              <p>{{ award.year || '-' }}年</p>
            </li>
            <li >
              <span>获奖等级：</span>
              <p>{{ award.degree !== 0 ? award.degreeCn : '-' }}</p>
            </li>
          </ul>
        </div>
      </div>

      <empty-view
        v-if="
          activeValue !== '相关人才' &&
          achievementData.length === 0 &&
          searchComp === false
        "
      />
      <div  v-if="achievementData.length === 0 && searchComp === true">
        <el-empty />
      </div>
    </div>
  </div>
</template>

<script>
import { formatToDate, formatToYearStr } from '@/utils/dateUtil';

export default {
  name: 'achievementList',
  components: {
  },
  // activeValue：切换到当前值
  // achievementData：成果的数据
  // total：数据数量
  // searchComp：是否在搜索组件中使用
  //patentParam：接口传入的值
  //isDialogText：区别创办/合作企业和专利合作弹窗
  props: [
    'activeValue',
    'achievementData',
    'total',
    'searchComp',
    'isDialogText',
    'patentParam',
    'backName',
  ],
  data() {
    return {
      formatToYearStr,
      formatToDate,

      sortValue: '',
      sortData: [],
      analyseViewBoo: false,
    };
  },
  created() {
    if (this.activeValue === '专利') {
      this.sortValue = '相关度';
      this.sortData = [{ name: '相关度' }, { name: '时间' }];
    } else if (this.activeValue === '论文') {
      // this.sortValue = '匹配度'
      // this.sortData = [{name:'匹配度'},{name:'引用数'},{name:'发表时间'}]
      this.sortValue = '引用数';
      this.sortData = [{ name: '引用数' }, { name: '发表时间' }]; // 发表时间暂时有问题，后端修改好之后可放开
      // this.sortData = [{name:'引用数'}]
    }
  },
  methods: {
    goPersonalDetails(id) {
      if (id) {
        let obj = {
          name: 'talentDetail',
          query: {
            id: id,
            isBack: '1',
            backName: this.backName,
          },
        };
        let routeData = this.$router.resolve(obj);
        window.open(routeData.href, '_blank');
      } else {
        this.$message.warning({
          message: '暂无详情数据',
          type: 'warning',
        });
      }
    },
    clickAnalyseView() {
      this.analyseViewBoo = true;
      this.$emit('clickAnalyseView', this.analyseViewBoo);
    },
    clickSortBy(value) {
      this.sortValue = value;
      this.$emit('paperSort', this.sortValue);
    },

    toDetail(id, path) {
      if (id) {
        this.$router.push({
          path: path,
          query: { id: id, isBack: '1', backName: this.backName },
        });
      } else {
        this.$message.warning({
          message: '无详情数据',
          type: 'warning',
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.achievement-list {
  //min-height: 300px;
  .achievement-top {
    padding: 4px 0 12px;
  }
  .achievement-view {
    padding: 10px 22px 0;
    background-color: #ffffff;
    border-radius: 16px 16px 0 0;
  }

  .all-data-tips {
    color: #344054;
    font-size: 14px;
    margin-left: 29px;

    span {
      color: #c3a062;
      font-size: 14px;
    }
    .hint-text {
      span {
        color: red;
      }
      font-size: 9px;
      color: #999999;
    }
  }

  .achievement-item {
    padding: 8px 0;

    &:not(:last-child) {
      border-bottom: 1px dashed #e8eaee;
    }

    .title {
      margin-bottom: 10px;
      max-width: 1100px;
      line-height: 19px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      span {
        font-size: 16px;
        color: #101828;
        cursor: pointer;
        //font-family: 'Microsoft YaHei', '微软雅黑';
        letter-spacing: 0.5px;

        &:hover {
          color: #2e1f88;
        }
      }
    }

    .info {
      display: flex;
      align-items: center;
      //margin-top: 10px;
      flex-wrap: wrap;

      li {
        display: flex;
        align-items: center;
        margin-right: 30px;
        margin-bottom: 10px;

        > span {
          color: #667085;
          font-size: 14px;
        }
        > p {
          font-size: 14px;
          max-width: 300px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #101828;
        }
      }

      li.inventor {
        p {
          margin-right: 10px;
          display: flex;
          align-items: center;

          span {
            color: #101828;
            font-size: 14px;
            margin-left: 5px;
          }
        }
      }
    }
  }

  .project-item {
    .info {
      .inventor {
        p {
          span {
            color: #101828 !important;
          }
        }
      }
    }
  }
}

.patent-layout {
  flex: 1;

  .patent-sort-view {
    margin-right: 21px;
    span {
      color: #344054;
      font-size: 14px;
    }
    p {
      color: #344054;
      font-size: 14px;
      margin-left: 10px;
    }
    .sort-line {
      margin-left: 3px;
      color: #2e1f88;
    }
    .p-select-color {
      color: #2e1f88;
      font-weight: bold;
    }
  }

  .patent-analyse-view {
    flex: 1;
    p {
      img {
        vertical-align: middle;
        margin-right: 5px;
        width: 22px;
        height: 19px;
      }
      color: #0c78c1;
      font-size: 12px;
    }
  }
}

.analyse-layout {
  margin-top: 10px;
}
</style>
